export default __webpack_public_path__ + "public/assets/images/4d492c143d9129bef6610acc91befdd2.png";